import {
  Box,
  Typography,
  Paper,
  Stack,
  Link,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
} from "@mui/material";
import QrCode2RoundedIcon from "@mui/icons-material/QrCode2Rounded";
import Iconify from "src/components/iconify/iconify";

export default function QRCodeDialog({ open, onClose }: any) {
  return (
    <Dialog maxWidth="lg" open={open} onClose={onClose}>
      <DialogTitle display="flex" p="10px 20px !important">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Typography variant="h6">WhatsApp</Typography>
          {onClose && (
            <IconButton onClick={onClose}>
              <Iconify icon="material-symbols:cancel-outline" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Paper
          sx={{
            display: "flex",
            flexDirection: "row",
            borderRadius: 3,
            p: 2,
            gap: 4,
            maxWidth: 900,
            width: "100%",
          }}
        >
          {/* Left Instructions */}
          <Box flex={1}>
            <Typography variant="h5" mb={2}>
              Steps to log in
            </Typography>
            <Stack spacing={2}>
              <Typography>1️⃣ Open WhatsApp 💬 on your phone 📱</Typography>
              <Typography>
                2️⃣ On Android tap <b>Menu ⋮</b>, on iPhone tap{" "}
                <b>Settings ⚙️</b>
              </Typography>
              <Typography>
                3️⃣ Tap <b>Linked devices</b>, then <b>Link device</b>
              </Typography>
              <Typography>4️⃣ Scan the QR code to confirm</Typography>
            </Stack>
          </Box>

          {/* Right QR Code */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: "#fffbe6",
              border: "1px solid #ddd",
              minHeight: 200,
            }}
          >
            {/* Replace with actual QR image or scanner */}
            <Box textAlign="center">
              <QrCode2RoundedIcon sx={{ fontSize: 150, color: "#ccc" }} />
              <Typography variant="body2" mt={1} color="text.secondary">
                Your QR Code will appear here
              </Typography>
            </Box>
          </Box>
        </Paper>
      </DialogContent>
    </Dialog>
  );
}
